/**
 * @module app.shared
 */

import { autoinject } from 'aurelia-framework';
import { addDelegatedEventListener, removeDelegatedEventListener } from 'app/shared/lib/listen-events';
import { getKey, Key } from 'app/shared/lib/keys';
import { CustomAttributeBase } from 'app/shared/attributes/abstracts/custom-attribute-base';

const CONFIRM_KEYS = [
    Key.Enter,
    Key.Space
]

@autoinject()
export class EssFocusableCustomAttribute extends CustomAttributeBase {

    // INFO [Matt] Tracks the original tabindex of the element for resetting it on detached.
    protected originalTabIndex: string | null = null;

    protected handleKeydown = (event: KeyboardEvent) => {
        if(!event.defaultPrevented && CONFIRM_KEYS.includes(getKey(event) as Key)) {
            event.preventDefault();
            this.element.click();
        }
    };

    protected attached() {
        addDelegatedEventListener(this.element, 'keydown', this.handleKeydown);
        this.originalTabIndex = this.element.getAttribute('tabindex');
        this.element.setAttribute('tabindex', '0');
    }

    protected detached() {
        removeDelegatedEventListener(this.element, 'keydown', this.handleKeydown);
        if(this.originalTabIndex !== null) {
            this.element.setAttribute('tabindex', this.originalTabIndex);
        } else {
            this.element.removeAttribute('tabindex');
        }
    }
}
